var _excluded = ["className", "operation", "investmentItem", "successCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { formValueSelector } from "redux-form";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery, DialogContent, DialogActions, Alert, AlertTitle } from "@mui/material";
import { PiMathOperations, PiShoppingCart } from "react-icons/pi";
import Dialog from "../../../components/mui/material/Dialog";
import Button from "../../../components/mui/material/Button";
import NumericFormat from "../../../components/react-number-format/NumericFormat";
import InvestmentItemAvatar from "../../../components/mui/material/InvestmentItemAvatar";
import { postOperations, resetPostOperations } from "../../../actions";
import { operationTypes, operationStateIds, operationForms, errorCodes, investmentItemTypeIds } from "../../../constants";
import ExchangeWizardForm from "./ExchangeWizardForm";
var tKey = "contexts.ExchangeContext.CreateExchangeDialog";
var selector = formValueSelector("exchangeWizard");
function CreateExchangeDialog(props) {
  if (!props.open) return null;
  var onClose = props.onClose,
    className = props.className,
    operation = props.operation,
    investmentItem = props.investmentItem,
    successCallback = props.successCallback;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var theme = useTheme();
  var fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  var dispatch = useDispatch();
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var authUser = useSelector(function (state) {
    return state.entities.users.byId[authUserId];
  });
  var user = operation.user || authUser;
  if (!operation.user) operation.user = user;
  var cart = useSelector(function (state) {
    return state.entities.carts.firstByUserIdAndOperationsStateIdOrderByUpdatedAtDesc[[user.id, operationStateIds.INCART].join("-")];
  });
  if (!operation.cart && cart) operation.cart = cart;
  var operationQuote = useSelector(function (state) {
    return selector(state, "quote");
  });
  var exchangeNow = useSelector(function (state) {
    return selector(state, "exchangeNow");
  });
  var currencyAmountAvailable = useSelector(function (state) {
    return selector(state, "currencyAmountAvailable");
  });
  var boost = useSelector(function (state) {
    return selector(state, "boost");
  });
  var postOperationsCall = useSelector(function (state) {
    return state.apiCalls.postOperations[operationForms.NEW] || {};
  });
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    savedOperation = _useState2[0],
    setSavedOperation = _useState2[1];
  function handleSubmit(values) {
    values.brokerId = values.broker.id;
    values.boostId = values.boost && values.boost.id;
    values.cartId = values.cart && values.cart.id;
    values.goalId = values.goal.id === -1 ? null : values.goal.id;
    values.variantInvestmentItemId = values.variantInvestmentItem.id;
    values.userId = values.user.id;
    values.quoteId = values.quote && values.quote.id;
    if (exchangeNow) {
      values.nextStateId = values.boostId ? operationStateIds.COMMITTED : values.broker.submitExchangeOperationListenerBeanName ? operationStateIds.SUBMITTED : operationStateIds.PENDING;
      values.cartId = undefined;
    } else {
      values.nextStateId = operationStateIds.INCART;
    }
    if (values.type === operationTypes.SELL) {
      values.investmentItemAmount = values.investmentItemAmount * -1;
      values.requestedCurrencyAmount = values.requestedCurrencyAmount * -1;
    }
    if (values.boost) values.investmentItemAmount = values.requestedCurrencyAmount / values.quote.price;
    dispatch(postOperations(operationForms.NEW, [values])).then(function (action) {
      if (action.response.success) {
        setSavedOperation(action.response._embedded[0]);
        successCallback && successCallback();
      }
    });
  }
  var forwardProps = function (_ref) {
    var className = _ref.className,
      operation = _ref.operation,
      investmentItem = _ref.investmentItem,
      successCallback = _ref.successCallback,
      rest = _objectWithoutProperties(_ref, _excluded);
    return rest;
  }(props);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, _extends({
    fullWidth: true,
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    scroll: "body",
    PaperProps: {
      className: className,
      elevation: 0,
      sx: {
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))"
      }
    },
    sx: {
      backdropFilter: "blur(5px) sepia(5%)"
    }
  }, forwardProps), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center p-5 rounded-top",
    style: {
      backgroundColor: investmentItem.pictureBackgroundColorHex
    }
  }, /*#__PURE__*/React.createElement(InvestmentItemAvatar, {
    size: "xl",
    investmentItem: investmentItem,
    imgClassName: "shadow border-0"
  })), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(ExchangeWizardForm, {
    initialValues: operation,
    investmentItem: investmentItem,
    onSubmit: handleSubmit
  }))), postOperationsCall && /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: fullScreen,
    open: postOperationsCall.message,
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    PaperProps: {
      elevation: 0,
      sx: {
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))"
      }
    }
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: postOperationsCall.success && savedOperation && savedOperation.state.id !== operationStateIds.PENDING_REVISION ? "success" : "error",
    sx: {
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(AlertTitle, null, postOperationsCall.success && savedOperation && exchangeNow && savedOperation.state.id !== operationStateIds.PENDING_REVISION && t("".concat(tKey, ".postOperationsCall_success_exchangeNow")), postOperationsCall.success && savedOperation && !exchangeNow && savedOperation.state.id !== operationStateIds.PENDING_REVISION && t("".concat(tKey, ".postOperationsCall_success_addToCart")), !postOperationsCall.success && t("".concat(tKey, ".postOperationsCall_error"))), postOperationsCall.success && exchangeNow && !boost && savedOperation && savedOperation.state.id !== operationStateIds.PENDING_REVISION && /*#__PURE__*/React.createElement(React.Fragment, null, operation.type === operationTypes.SELL && (operation.investmentItem.type.id === investmentItemTypeIds.CEDEAR || operation.investmentItem.type.id === investmentItemTypeIds.STOCK || operation.investmentItem.type.id === investmentItemTypeIds.BOND || operation.investmentItem.type.id === investmentItemTypeIds.BILL) && /*#__PURE__*/React.createElement("p", null, t("".concat(tKey, ".postOperationsCall_success_exchangeNow_noBoost_48"))), operation.type.id === operationTypes.SELL && operation.investmentItem.type.id === investmentItemTypeIds.FUND && /*#__PURE__*/React.createElement("p", null, t("".concat(tKey, ".postOperationsCall_success_exchangeNow_noBoost_24")))), postOperationsCall.success && exchangeNow && boost && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".postOperationsCall_success_exchangeNow_boosts_p1"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    }
  })), /*#__PURE__*/React.createElement("p", null, t("".concat(tKey, ".postOperationsCall_success_exchangeNow_boosts_p2")))), postOperationsCall.success && exchangeNow && savedOperation && savedOperation.state.id === operationStateIds.PENDING_REVISION && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".postOperationsCall_exchangeNow_pendingRevision_p1"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    }
  })), /*#__PURE__*/React.createElement("p", null, t("".concat(tKey, ".postOperationsCall_exchangeNow_pendingRevision_p2")))), postOperationsCall.success && !exchangeNow && /*#__PURE__*/React.createElement("p", null, t("".concat(tKey, ".postOperationsCall_success_addToCart_p1"))), !postOperationsCall.success && !postOperationsCall.errorCode && postOperationsCall.message, !postOperationsCall.success && postOperationsCall.errorCode === errorCodes.MARKET_IS_CLOSED && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, t("".concat(tKey, ".postOperationsCall_error_marketIsClosed_p1"))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("ul", {
    style: {
      display: "inline-block",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".postOperationsCall_error_marketIsClosed_p2_li1"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".postOperationsCall_error_marketIsClosed_p2_li2"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".postOperationsCall_error_marketIsClosed_p2_li3"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".postOperationsCall_error_marketIsClosed_p2_li4"),
    components: {
      b: /*#__PURE__*/React.createElement("b", null)
    }
  }))))), !postOperationsCall.success && operationQuote && postOperationsCall.errorCode === errorCodes.INSUFFICIENT_CASH && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, t("".concat(tKey, ".postOperationsCall_error_insufficientCash_p1"))), /*#__PURE__*/React.createElement("p", null, t("".concat(tKey, ".postOperationsCall_error_insufficientCash_p2")), /*#__PURE__*/React.createElement(NumericFormat, {
    displayType: "text",
    value: currencyAmountAvailable,
    className: "me-1",
    style: {
      fontWeight: 600
    }
  }), /*#__PURE__*/React.createElement("small", null, operationQuote.currency.unitAbbreviation)), /*#__PURE__*/React.createElement("p", null, t("".concat(tKey, ".postOperationsCall_error_insufficientCash_p3")), /*#__PURE__*/React.createElement(NumericFormat, {
    displayType: "text",
    value: operationQuote.amount,
    className: "me-1",
    style: {
      fontWeight: 600
    }
  }), /*#__PURE__*/React.createElement("small", null, operationQuote.currency.unitAbbreviation))), /*#__PURE__*/React.createElement(DialogActions, null, postOperationsCall.success ? /*#__PURE__*/React.createElement(React.Fragment, null, exchangeNow ? /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    startIcon: /*#__PURE__*/React.createElement(PiMathOperations, null),
    className: "me-2",
    onClick: function onClick() {
      return navigate("/users/".concat(operation.user.username, "/operations"));
    }
  }, t("".concat(tKey, ".postOperationsCall_success_goToOperations"))) : /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    startIcon: /*#__PURE__*/React.createElement(PiShoppingCart, null),
    className: "me-2",
    onClick: function onClick() {
      dispatch(resetPostOperations(operationForms.NEW));
      navigate("/cart");
    }
  }, t("".concat(tKey, ".postOperationsCall_success_goToCart"))), /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    style: {
      fontWeight: 600
    },
    onClick: function onClick() {
      dispatch(resetPostOperations(operationForms.NEW));
      onClose();
    }
  }, t("".concat(tKey, ".postOperationsCall_success_continue")))) : /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    onClick: function onClick() {
      dispatch(resetPostOperations(operationForms.NEW));
      onClose();
    }
  }, t("".concat(tKey, ".postOperationsCall_error_close")))))));
}
CreateExchangeDialog.propTypes = {
  className: PropTypes.string,
  operation: PropTypes.object.isRequired,
  investmentItem: PropTypes.object.isRequired,
  successCallback: PropTypes.func
};
export default CreateExchangeDialog;